import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-row" };
const _hoisted_2 = { class: "chat-widget-sidebar" };
import { SIDEBAR_TAB_KEYS } from '@/helper/const';
import { UITabPane, UITabs } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import BuilderPreview from './BuilderPreview.vue';
import ChatWindow from './Sidebar/ChatWindow.vue';
import Messaging from './Sidebar/Messaging.vue';
import Styles from './Sidebar/Styles.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuilderSidebar',
    setup(__props) {
        const activeTab = ref(SIDEBAR_TAB_KEYS.WIDGET);
        const handleChangeTab = (tabName) => {
            activeTab.value = tabName;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(UITabs), {
                        type: 'line',
                        animated: true,
                        defaultValue: _unref(SIDEBAR_TAB_KEYS).WIDGET,
                        justifyContent: 'center',
                        value: activeTab.value,
                        "onUpdate:value": handleChangeTab
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UITabPane), {
                                tab: _unref(SIDEBAR_TAB_KEYS).WIDGET,
                                name: _unref(SIDEBAR_TAB_KEYS).WIDGET
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(Styles)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["tab", "name"]),
                            _createVNode(_unref(UITabPane), {
                                tab: _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW,
                                name: _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(ChatWindow)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["tab", "name"]),
                            _createVNode(_unref(UITabPane), {
                                tab: _unref(SIDEBAR_TAB_KEYS).MESSAGING,
                                name: _unref(SIDEBAR_TAB_KEYS).MESSAGING
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(Messaging)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["tab", "name"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["defaultValue", "value"])
                ]),
                _createVNode(BuilderPreview, { activeTab: activeTab.value }, null, 8 /* PROPS */, ["activeTab"])
            ]));
        };
    }
});
